import {useCurrentMaterialStorages} from '@domain/material-storage'
import type {MaterialStorage} from '@domain/material-storage'

import {useUrlParam} from '../../../../modules/routing'
import {isStorageWithMaterialGuard} from '../../../../modules/storages'

const selector = (data: MaterialStorage[]) => data.filter(isStorageWithMaterialGuard)

export const useStoragesWithMaterialQuery = () => {
  const plantCode = useUrlParam('plantCode')
  return useCurrentMaterialStorages({
    plantId: plantCode,
    options: {select: selector}
  })
}
